module.exports = __webpack_public_path__ + "img/arrow-right-pl-yellow.0d35a56e.svg";